module.exports = __webpack_public_path__ + "img/acf6e169a1694012b0b30efc536598b7.1d871803.jpg";